<template>
  <div class="channel-container">
    <div class="item" v-for="item of topicList" :key="item.id">
      <div class="item-left">
        <div class="title">{{ item.title }}</div>
        <div class="des">{{ item.description }}</div>
        <div class="enter" @click="changeUrl(item.url)">
          进入{{ item.name }} >
        </div>
      </div>
      <div class="item-right">
        <img :src="item.pic" alt="" />
      </div>
    </div>
    <div class="item">
      <div class="item-left">
        <div class="title">更多频道</div>
        <div class="more">
          <div
            v-for="item of topicMenu"
            :key="item.id"
            @click="changeUrl(item.url)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexChannel",
  props: ["topic"],
  computed: {
    topicList() {
      return this.topic.slice(0, 3);
    },
    topicMenu() {
      return this.topic.slice(3);
    }
  },
  methods: {
    changeUrl(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="stylus" scoped>
.channel-container
  width 1200px
  height 160px
  margin 0 auto
  display flex
  border 1px solid #e4e4e4
  .item
    width 25%
    border-right 1px solid #e4e4e4
    display flex
    background #fff
    &:nth-child(4)
      border-right 0
    &-left
      flex 1
      padding-top 15px
      padding-left 20px
      .title
        font-family 'Microsoft yahei'
        font-size 15px
      .more
        display flex
        flex-wrap wrap
        margin-top 10px
        div
          width 33.33%
          height 24px
          line-height 24px
          font-family 'Microsoft yahei'
          font-size 12px
          color #545454
          cursor pointer
          &:hover
            color #377bee
      .des
        height 36px
        color #999999
        padding-top 6px
        overflow hidden
        line-height 17px
      .enter
        padding-top 10px
        color #377bee
        font-family '宋体'
        cursor pointer
    &-right
      width 135px
      img
        width 100%
        height 100%
</style>
